import type { CSSProperties } from 'react'
import { freedomTarget, passiveIncome, totalExpenses } from '../game/finance'
import type { GameState } from '../game/types'
import { money } from '../util/format'

interface Props {
  g: GameState
  inspecting: number | null
  onSelect: (id: number) => void
}

export function PlayerStrip({ g, inspecting, onSelect }: Props) {
  return (
    <div className="player-strip">
      {g.players.map((p) => {
        const passive = passiveIncome(g, p)
        const target = freedomTarget(g, p)
        const progress = target > 0 ? Math.min(1, passive / target) : 0
        const active = g.current === p.id
        const selected = inspecting === p.id
        return (
          <button
            key={p.id}
            className={`pcard${active ? ' active' : ''}${selected ? ' selected' : ''}${p.bankrupt ? ' out' : ''}`}
            style={{ '--tk': p.character.color } as CSSProperties}
            onClick={() => onSelect(p.id)}
          >
            <span className="pcard-top">
              <span className="pcard-ava">{p.character.emoji}</span>
              <span className="pcard-id">
                <strong>
                  {p.name}
                  {p.isBot && <span className="bot-tag">BOT</span>}
                </strong>
                <span className="faint">
                  {p.profession.emoji} {p.profession.name}
                </span>
              </span>
              <span className="pcard-cash num">{money(p.cash)}</span>
            </span>

            <span className="pcard-bar" title={`Passive ${money(passive)} / เป้า ${money(target)}`}>
              <i style={{ width: `${progress * 100}%` }} />
            </span>

            <span className="pcard-meta">
              <span className="dim num">
                💰 {money(passive)} <span className="faint">/ {money(totalExpenses(p))}</span>
              </span>
              <span className="pcard-badges">
                {p.shield > 0 && <span title="โล่พลังงาน">🛡️{p.shield > 1 ? p.shield : ''}</span>}
                {p.quarantine > 0 && <span title={`ถูกกักกัน ${p.quarantine} ตา`}>🧊{p.quarantine}</span>}
                {p.skipTurns > 0 && <span title={`ข้ามตา ${p.skipTurns} ตา`}>😴{p.skipTurns}</span>}
                {p.children > 0 && <span title={`มีลูก ${p.children} คน`}>👶{p.children}</span>}
                {p.effects.map((e) => (
                  <span key={e.uid} className={e.good ? 'good-text' : 'bad-text'} title={`${e.label} (${e.turnsLeft} ตา)`}>
                    {e.emoji}
                  </span>
                ))}
              </span>
            </span>

            {p.bankrupt && <span className="pcard-out">ล้มละลาย</span>}
          </button>
        )
      })}
    </div>
  )
}
